export function getRouterBasename(): string {
  const base = import.meta.env.BASE_URL;
  return base.endsWith('/') ? base.slice(0, -1) : base;
}

export function getRestApiRoot(): string {
  return `${import.meta.env.BASE_URL}api/v1`;
}
